import { render } from "./MenuItem.vue?vue&type=template&id=44bc7f70&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=44bc7f70&lang=scss&scoped=true"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bc7f70"]])

export default __exports__